<template>
  <div class="header-middle" :class="{isVertical: isAtSportsPage}">
    <ul class="down-nav">
      <li v-for="(item,index) in mainNav" :key="index">
        <a
          class="nav-name game-box"
          @click.prevent="navHandleClick(item)"
          :class="[{isHot: mainNavHot.includes(index)}, {'big-prize': mainNavPrize.includes(index)},{green: index === 8},{yellow: index===1||index===2||index===3}]"
        >
          <p>{{item.navName}}</p>
        </a>
        <div class="subnav" v-if="item.gameList.length>0">
          <ol class="gameList" :class="{gameListLang: item.gameList.length>=10}">
            <li
              v-for="(gameItem,gameIndex) in item.gameList"
              :class="{itemHot: gameItem.isHeat == 1}"
              @click="goGame(gameItem)"
              :key="gameIndex"
            >
              <div>{{gameItem.fullName}}</div>
            </li>
          </ol>
        </div>
      </li>
      <li>
        <a @click.prevent="goService" href="#" class="nav-name">
          <p>在线客服</p>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
/*eslint-disable*/
import { commonApi, common } from "@/common/index";
import { mapState, mapMutations } from "vuex";

export default {
  name: "main-nav",
  data() {
    return {
      // 游戏列表
      chessList: [],
      slotList: [],
      catchFishList: [],
      liveCList: [],
      sportsList: [],
      lotteryList: [],
      DList: [],
      discountList: [],
      mainNav: [
        // 一级导航
        {
          navName: "首页",
          subName: "HOME",
          url: "/",
          gameType: "-1",
          gameList: []
        },
        {
          navName: "棋牌游艺",
          subName: "CHESS CARDS",
          url: "/chess",
          gameType: "6",
          gameList: []
        },
        {
          navName: "捕鱼达人",
          subName: "FISHING",
          url: "/catchFish",
          gameType: "5",
          gameList: []
        },
        {
          navName: "电子游艺",
          subName: "SLOT",
          url: "/slots",
          gameType: "1",
          gameList: []
        },
        {
          navName: "真人视讯",
          subName: "LIVE",
          url: "/liveCasino",
          gameType: "2",
          gameList: []
        },
        {
          navName: "电子竞技",
          subName: "SPORTS",
          url: "/esports",
          isEsport: true,
          gameType: "3",
          gameList: []
        },
        {
          navName: "体育投注",
          subName: "SPORTS",
          url: "/sports",
          gameType: "3",
          gameList: []
        },

        // {navName: '泛亚电竞', subName: 'SPORTS', url: '', gameType: '-2', gameList: []},
        {
          navName: "彩票游戏",
          subName: "LOTTERY",
          url: "/lottery",
          gameType: "4",
          gameList: []
        },
        {
          navName: "优惠活动",
          subName: "PROMOTION",
          url: "/discounts",
          gameType: "99",
          gameList: [
            {
              fullName: "周五狂欢节",
              path: "/discounts/all",
              platformCode: "firstDiscount",
              gameType: "99"
            },
            {
              fullName: "真人首存38%",
              path: "/discounts/all",
              platformCode: "",
              gameType: "99"
            },
            {
              fullName: "体育首存28%",
              path: "/discounts/all",
              platformCode: "",
              gameType: "99"
            },
            {
              fullName: "电子首存100%",
              path: "/discounts/all",
              platformCode: "",
              gameType: "99"
            },
            {
              fullName: "电子笔笔存送25%",
              path: "/discounts/all",
              platformCode: "",
              gameType: "99"
            },
            {
              fullName: "活动大厅",
              path: "/discountsHall",
              platformCode: "",
              gameType: "99"
            }
          ]
        }
        // {navName: 'vip俱乐部', subName: 'VIP', url: '/privilege', gameType: '-1', gameList:[]}
      ],
      noHot: [
        "bbin",
        "ky",
        "lucky",
        "ebet",
        "hb",
        "sa",
        "vt",
        "dt",
        "mg",
        "jdb",
        "pt",
        "ag",
        "allbet",
        "kg",
        "firstdiscount",
        "newag",
        "newpt",
        "cq"
      ],
      mainNavHot: [3, 5, 1, 7, 8],
      // 中大奖
      mainNavPrize: [2]
    };
  },
  computed: {
    ...mapState({
      customerUrl: state => state.linkList.customerUrl,
      isLogin: state => state.isLogin,
      UUID: state => state.UUID,
      isAtSportsPage: state => state.isAtSportsPage
    })
  },
  methods: {
    ...mapMutations(["setShowLoginBox"]),
    navHandleClick(obj) {
      if (obj.url) {
        this.$router.push({ path: obj.url });
        return;
      }
      // 泛亚电竞
      if (obj.gameType === "-2") {
        let avia = {
          fullName: "泛亚电竞",
          gameType: "3",
          platformCode: "AVIA",
          platformDescribe: "泛亚电竞",
          platformKey: "AVIA_SPORT",
          platformName: "AVIA"
        };
        this.goGame(avia);
      }
    },
    goService() {
      window.open(this.customerUrl, "", "height=500, width=600");
    },
    // 分类游戏
    sortGame(data) {
      let allGame = data;
      if (allGame.length > 0) {
        allGame.forEach(item => {
          switch (item.gameType) {
            case "1":
              this.slotList.push(item);
              break;
            case "2":
              this.liveCList.push(item);
              break;
            case "3":
              this.sportsList.push(item);
              break;
            case "4":
              this.lotteryList.push(item);
              break;
            case "5":
              this.catchFishList.push(item);
              break;
            case "6":
              this.chessList.push(item);
              break;
          }
        });
        this.mainNav.forEach((item, index, arr) => {
          switch (item.gameType) {
            case "1":
              arr[index].gameList = this.slotList;
              break;
            case "2":
              arr[index].gameList = this.liveCList;
              break;
            case "3": //电竞和体育
              if (item.isEsport) {
                arr[index].gameList = this.sportsList.filter(obj => {
                  return obj.isESports === "1";
                });
              } else {
                arr[index].gameList = this.sportsList.filter(obj => {
                  return obj.isESports !== "1";
                });
              }
              break;
            case "4":
              arr[index].gameList = this.lotteryList;
              break;
            case "5":
              arr[index].gameList = this.catchFishList;
              break;
            case "6":
              arr[index].gameList = this.chessList;
              break;
          }
        });
      }
    },
    // 获取游戏
    getAllGameInfo() {
      commonApi.HOMEBEFORE.allGameInfo()
        .then(data => {
          this.sortGame(data);
        })
        .catch(err => {});
    },
    // 进入游戏
    goGame(item) {
      if (item.platformCode === "XSPORT") {
        common.goXsports(this.isLogin,this.UUID);
        return;
      }
      if (item.gameType == "99") {
        this.$router.push({ path: item.path });
        return;
      }

      if (item.gameType == "1") {
        this.$router.push({
          path: "/slots",
          query: { platformCode: item.platformCode }
        });
      } else {
        common.jinsha_GoGame(item, this.isLogin, this.UUID);
      }
    }
  },
  mounted() {
    this.getAllGameInfo();
  }
};
</script>

<style scoped lang="scss">
.header-middle {
  .down-nav {
    position: relative;
    text-align: center;
    width: 1000px;
    margin: auto;
    &:hover {
      overflow: visible;
    }
  }
  .down-nav > li {
    cursor: pointer;
    width: 89px;
    display: inline-block;
    padding: 10px 5px;
    position: relative;
    vertical-align: top;
    &:hover {
      .subnav {
        display: block;
      }
    }
    .nav-name {
      position: relative;
      display: inline-block;
      border-radius: 6px;
      width: 100%;
      height: 30px;
      line-height: 30px;
      color: #fff;
      text-align: center;
      text-decoration: none;
      font-size: 14px;
      p {
        font-size: 14px;
        &:hover {
          color: #6e3a0f;
          background: url("../../assets/images/headerNav/middle/g_navi_over.png")
            no-repeat center center;
          background-size: 100% 100%;
        }
      }
    }
    .green {
      p {
        color: #08d803;
      }
    }
    .yellow {
      p {
        color: #ff0;
      }
    }
    .isHot {
      &:before {
        content: "";
        transition: all 0.5s;
        position: absolute;
        top: -5px;
        right: -10px;
        display: inline-block;
        width: 23px;
        height: 26px;
        background: url("../../assets/images/headerNav/middle/hot.gif")
          no-repeat center top;
      }
    }
    .big-prize {
      &:before {
        content: "";
        transition: all 0.5s;
        position: absolute;
        top: -5px;
        right: -10px;
        display: inline-block;
        width: 23px;
        height: 26px;
        background: url("../../assets/images/headerNav/middle/prize.gif")
          no-repeat center top;
      }
    }
    //箭头
    .subnav:before {
      content: "";
      position: absolute;
      top: -10px;
      right: 0;
      display: inline-block;
      width: 100%;
      height: 10px;
      background: url("../../assets/images/headerNav/middle/subnav_arrow.png")
        no-repeat 32px bottom;
      background-size: 15px 10px;
    }
    //下拉框
    .subnav {
      transition: all 0.5s;
      display: none;
      position: absolute;
      z-index: 3;
      top: 99%;
      left: 0;
      background: url("../../assets/images/headerNav/middle/bg.png") repeat;
      border: 2px solid #f8e978;
      .gameList {
        text-align: left;
        overflow: hidden;
        padding: 10px;
        .itemHot {
          &:before {
            content: "";
            transition: all 0.5s;
            animation: upDown 0.5s infinite;
            position: absolute;
            top: 7px;
            right: -10px;
            display: inline-block;
            width: 23px;
            height: 26px;
            background: url("../../assets/images/headerNav/middle/hot.gif")
              no-repeat center center;
          }
        }
        li {
          display: inline-block;
          position: relative;
          border-bottom: 1px dotted rgba(255, 255, 255, 0.3);
          vertical-align: top;
          width: 115px;
          color: #fff;
          font-size: 13px;
          line-height: 35px;
          text-align: center;
          &:hover {
            color: #ffd053;
            cursor: pointer;
          }
          div {
            height: 100%;
          }
        }
      }
      .gameListLang {
        width: 260px;
        li {
          &:nth-child(even) {
            margin-left: 10px;
          }
        }
      }
    }
  }
  .down-nav > :first-child {
    position: static;
  }
}
.isVertical {
  position: relative;
  top: -5px;
  .down-nav {
    width: 150px;
    margin: 0;
    text-align: center;
    padding: 50px 0 30px;
    background: url("../../assets/images/headerNav/middle/vertical-nav.png")
      no-repeat top center;
    background-size: 100% 100%;
    & > li {
      width: 100%;
      padding: 2px 0;
      .subnav {
        left: 170px;
        top: 0;
        &:before {
          content: "";
          left: -33px;
          top: 0;
          width: 35px;
          height: 30px;
          background-position: center bottom;
          transform: rotate(-90deg);
        }
        .gameList {
          .itemHot {
            &:before {
              top: -2px;
            }
          }
        }
      }
      .isHot,
      .big-prize {
        &:before {
          right: 10px;
        }
      }
      &:hover {
        .nav-name {
          p {
            color: #6e3a0f;
            background: url("../../assets/images/headerNav/middle/g_navi_over.png")
              no-repeat center center;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/build08/components/nav/main-nav.vue